import { Component, Input, OnInit } from '@angular/core';
import { isEmpty } from 'lodash';
import { merge } from 'rxjs';
import { Pagamento } from 'src/app/pagamento/models/pagamento';
import { Bloqueio, ReservaBloqueio } from 'src/app/pagamento/models/reserva-bloqueio';
import { PagamentoService } from 'src/app/pagamento/services/pagamento.service';
import { ScopedMessageService } from 'src/app/shared/services/scoped-message.service';

@Component({
  selector: 'reserva-bloqueio-detalhes',
  templateUrl: './reserva-bloqueio-detalhes.component.html',
  styleUrls: ['./reserva-bloqueio-detalhes.component.css'],
  providers: [ScopedMessageService]
})
export class ReservaBloqueioDetalhesComponent implements OnInit {
  @Input() public pagamento: Pagamento;
  @Input() public collapsed: boolean = true;

  public reservaBloqueioLista: ReservaBloqueio[];
  public initError: boolean = false;
  public scopeId: string;

  constructor(
    private pagamentoService: PagamentoService,
    private scopedMessageService: ScopedMessageService,
  ) { }

  public ngOnInit(): void {
    this.onCollapsedChange(this.collapsed);
    this.scopeId = this.scopedMessageService.scopeId;
  }

  public onCollapsedChange(collapsed: boolean): void {
    this.collapsed = collapsed;

    if (this.collapsed || this.reservaBloqueioLista != null) {
      return null;
    }

    this.carregarBloqueiosManuais();
  }

  private carregarBloqueiosManuais(): void {
    const mergedRequest = merge(
      this.pagamentoService.obterBloqueiosRestituicao(this.pagamento.pgtoNrIdAr),
      this.pagamentoService.obterBloqueiosManuais(this.pagamento.pgtoNrIdAr)
    )

    mergedRequest.subscribe({
      next: (bloqueio: Bloqueio[]) => {
        if (this.reservaBloqueioLista == null) {
          this.reservaBloqueioLista = [];
        }

        this.reservaBloqueioLista.push(...bloqueio.map(b => new ReservaBloqueio(b)));
      },
      error: () => {
        this.scopedMessageService.showError('Ocorreu um erro na consulta de bloqueios manuais');
        this.initError = true;
      },
      complete: () => {
        if (isEmpty(this.reservaBloqueioLista)) {
          this.scopedMessageService.showInfo('Nenhum registro encontrado');
          this.initError = true;
        }
      }
    });
  }
}
